(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("versionService", ["$http", "$sessionStorage", "$uibModal", versionService]);
    function versionService($http, $sessionStorage, $uibModal) {
        var versionServiceFactory = {};
        var open = false;
        versionServiceFactory.isOpen = function () {
            return open;
        };
        var getVersion = function () {
            return $http({ method: "GET", url: "/api/version" });
        };
        var getNewVersion = function () {
            var modal = $uibModal.open({
                templateUrl: "app/templates/newSBVersionModalTemplate.html",
                controller: ["$templateCache", "$timeout", "$window", function ($templateCache, $timeout, $window) {
                        var vm = this;
                        vm.refreshSBVersion = function () {
                            modal.close();
                            delete $sessionStorage.version;
                            $templateCache.removeAll();
                            $timeout(function () { $window.location.reload(true); }, 1000);
                        };
                    }],
                controllerAs: "vm",
                backdrop: "static",
                animation: false,
                keyboard: false
            });
            open = true;
            modal.result.catch(angular.noop);
            modal.result.finally(function () {
                open = false;
            });
        };
        versionServiceFactory.getVersion = getVersion;
        versionServiceFactory.getNewVersion = getNewVersion;
        return versionServiceFactory;
    }
}());
